import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CustomButton from 'shared/custom-button/CustomButton';
import { colors } from 'app/providers/theme/colors-type';
import styles from 'pages/mite-policy/MitePolicy.module.css';
import { StepOne } from 'features/mite-policy/step-1/StepOne';
import UgskLogo from 'shared/assets/UgskLogo';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { DefaultId, FormFieldsStepOne } from 'entities/mite-policy/step-1/selector';
import { StepTwo } from 'features/mite-policy/step-2/StepTwo';
import { Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation } from 'react-router-dom';
import { StepTree } from 'features/mite-policy/step-3/StepTree';
import { useEffect, useState } from 'react';
import { Polis } from 'entities/mite-policy/step-3/selector';
import { ProductID, SellerID } from 'entities/main-page/selector';
import { fetchDictionaries } from 'entities/main-page/action/fetch-main-page';
import { fetchDefaultId } from 'entities/mite-policy/step-1/action/fetch-step-one';

const steps = ['Предрасчёт', 'Оформление', 'Оплата'];

export const MitePolicy: React.FC = () => {
    const [activeStep, setActiveStep] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();

    const sellerID = useAppSelector(SellerID);
    const productID = useAppSelector(ProductID);
    const ID = location.state?.id;
  
    const [triggerPay, setTriggerPay] = useState(false);

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const stepOneForm = useAppSelector(FormFieldsStepOne);
    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);
    const defaultId = useAppSelector(DefaultId);


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const stepperActiveStep = activeStep === 2 && triggerPay ? 3 : activeStep;
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!sellerID) {
            dispatch(fetchDictionaries({ SellerId: sellerID, Id: ID, DefaultId: defaultId }))
        }
    }, [sellerID, ID, defaultId]);


    return (
        <>
            <Box className={styles.titleContainer}>
                <UgskLogo />
            </Box>
            <Box className={styles.stepsTextContainer}>
                {steps.map((label, index) => (
                    <Typography
                        key={label}
                        className={`${styles.stepText} ${isMobile ? '' : styles.stepTextDesktop} ${activeStep === index ? styles.stepTextActive : ''}`}
                    >
                        {label}
                    </Typography>
                ))}
            </Box>

            <Box className={styles.stepperContainer}>
                <Stepper
                    activeStep={stepperActiveStep}
                    className={styles.stepper}
                    sx={{
                        '& .MuiStep-root': {
                            '& .MuiStepLabel-root': {
                                '& .Mui-active': {
                                    color: colors.primary,
                                },
                            },
                            '& .MuiStepIcon-root': {
                                '&.Mui-active': {
                                    color: colors.primary,
                                },
                                '&.Mui-completed': {
                                    color: colors.primary,
                                },
                            },
                        },
                    }}
                >
                    {steps.map((label) => (
                        <Step key={label} className={styles.stepperStep}>
                            <StepLabel className={styles.stepperLabel} />
                        </Step>
                    ))}
                </Stepper>
            </Box>
            {activeStep === steps.length ? (
                <Typography sx={{ mt: 2, mb: 1 }}>Все шаги завершены</Typography>
            ) : (
                <>
                    {activeStep === 0 && <StepOne ID={ID} windowWidth={windowWidth} />}
                    {activeStep === 1 && <StepTwo handleNext={handleNext} windowWidth={windowWidth} />}
                    {activeStep === 2 && <StepTree setTriggerPay={setTriggerPay} />}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, alignItems: 'center' }}>
                        {activeStep > 0 && !triggerPay && (
                            <Button onClick={handleBack} className={styles.btnBack}>
                                <KeyboardBackspaceIcon /> Вернуться к шагу {steps[activeStep - 1]}
                            </Button>
                        )}
                        <Box sx={{ flex: '1 1 auto' }} />
                        {activeStep !== 1 && stepOneForm.Price !== 0 && activeStep !== 2 && (
                            <CustomButton
                                title="Продолжить"
                                handleClick={handleNext}
                                textColor="white"
                                backgroundColor={colors.primary}
                                width="150px"
                                gap="10px"
                                borderRadius='4px'
                                padding='3px'
                            />
                        )}
                    </Box>
                </>
            )}

        </>
    );
};
